import React from "react";
import TabTemplate from "../../../_shoru_shared_library/template/TabTemplate";
import choicesTabRouter from "./choicesTabRouter";

function ChoicesTab(props) {

  return (
    <TabTemplate 
      router={choicesTabRouter}
      passData={props.passData}
    />
  )

}

export default ChoicesTab;